export default __webpack_public_path__ + "static/media/tundra.e04c02c9.png";